import role from '../helpers/role';

import Performance from '../statistic/Performance.vue';
import NewPerformance from '../statistic/NewPerformance.vue';


const routes = [{
	path: '/performance',
	name: 'performance',
	component: Performance,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/newperformance',
	name: 'newperformance',
	component: NewPerformance,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}, {
	path: '/updateperformance/:id',
	name: 'updateperformance',
	component: NewPerformance,
	meta: {
		authorize: [{ name: role.Statistiker }],
	},
}];

export default routes;
